'use strict';

/**
 * Initialize campaign form
 */

function initializeFormEvent() {
    let $campaignForm = $('.campaign-form');
    
    if ($campaignForm.length) {
        $('.campaign-form .register').on('click', function (e) {
            e.preventDefault();
            if ($campaignForm.valid()) {
                var dataToPost = 'dwfrm_campaign_register=dwfrm_campaign_register' + '&' + $campaignForm.serialize();

                $.ajax({
                    type: 'POST',
                    url: $campaignForm.attr('action'),
                    async: false,
                    data: dataToPost,
                    success: function (response) {
                        location.reload();
                        $(window).scrollTop(0);
                    }
                });
            }

        });
    }

    $('.campaign-success-popup .code-block').on('click', function () {
        let copyText = $('#campaign-promo-code').text();
        let $toCopy = $('#to-copy');
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(copyText).then(function () {
                if ($toCopy.length) {
                    $toCopy.hide();
                    $('#copied').css('display', 'flex');
                }
            });
        } else {
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val(copyText).select();
            document.execCommand('copy');
            $temp.remove();

            if ($toCopy.length) {
                $toCopy.hide();
                $('#copied').css('display', 'flex');
            }
        }
    });
}
export default {
    init : function () {
    initializeFormEvent();
    }
}
